import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'airport-offices' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
